export default "__VITE_ASSET__BdJhyvoh__"